import React from 'react'

const Mtech = () => {
  return (
    <div className="album py-2">
      <li>
        <a
          className="remove-underline color-black"
          target={"_blank"}
          href=""
        >
          <b> People1 </b>
        </a>
        (2018-2022)
      </li>
  </div>
  )
}

export default Mtech